module.exports = __webpack_public_path__ + "static/media/ola_polish.3693a66e.mp3";